'use strict';

var _ = require('lodash');

function MeasurementLayerEditorController ($scope, Flux, MeasurementStore) {
  var ctrl = this;
  var AnnotationStore = Flux.Store.get('AnnotationStore');

  this.colors = _.pluck(AnnotationStore.COLORS, 'color');
  this.measurementName = '-';

  if (MeasurementStore.get('active')) {
    this.measurementName = MeasurementStore.get('active').name;
  }

  this._handleColorSelected = function _handleColorSelected (ev, data) {
    var style = ctrl.measurementLayer.data.properties.style;

    if (!style) {
      ctrl.measurementLayer.data.properties.style = {};
      style = ctrl.measurementLayer.data.properties.style;
    }
    style.color = data;
    ctrl.measurementLayer.data.properties.style.color = data;

    ctrl.refreshLayerStyle({
      color : data
    });
  };

  this.hide = function hide () {
    $scope.$emit('measurementLayer:editor:close');
  };

  this.onMeasurementNameUpdated = function onMeasurementNameUpdated() {
    this.measurementName = MeasurementStore.get('active').name || '-';
  };

  $scope.$on('colorpicker:selected', this._handleColorSelected.bind(this));
  MeasurementStore.on(MeasurementStore.Events.NameUpdated, this.onMeasurementNameUpdated.bind(this));
}

MeasurementLayerEditorController.$inject = ['$scope', 'sbFlux', 'MeasurementStore'];
module.exports = MeasurementLayerEditorController;



// WEBPACK FOOTER //
// ./src/app/dash/map/measurementLayerEditor/MeasurementLayerEditorController.js